<template>
  <div id="app">
    <div id="nav">
      <router-link :to="{ name: 'EventList' }">Foty</router-link> |
      <router-link :to="{ name: 'About' }">About</router-link>
    </div>
    <router-view />
  </div>
</template>

<style>
#app {
  background-color: rgb(181, 181, 192);
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
  background-color: rgb(0, 0, 0);
  border-block-end-style:ridge;
}

#nav a {
  font-weight: bold;
  color: #ece9f7;
}

#nav a.router-link-exact-active {
  color: #f0ecf3;
}

h4 {
  font-size: 20px;
}
img {
  pointer-events: none;
}
</style>
